<template>
  <div class="row" :class="{'section-loading': isLoading}">
    <div class="col-12">
      <h4 class="text-green text-center">身故及完全失能保險金</h4>
      <div class="mb-15">
        <select
          v-model="yearperiod"
          class="form-control form-control-inline form-wide ml-50 w-100"
          >
          <option v-for="item in yearType" :key="`yearType-${item.value}`" :value="item.value">
            {{item.text}}
          </option>
        </select>
      </div>
      <form class="form">
        <div class="panel panel-form searchArea">
          <!-- 保障期間 -->
          <div class="form-group row">
            <label class="col-1 text-right">保障期間</label>
            <div class="col-11 d-inline-grid">
              <!-- 保障期間-1 -->
              <div class="radio radio-inline mb-15">
                <input type="radio" id="coveragePeriod-1" v-model="coveragePeriod" value="1">
                <label class="hide-label" for="coveragePeriod-1"></label>
                <span class="lh-40 ml-50">第</span>
                <input
                  type="number"
                  min="0"
                  v-model="startYear_1"
                  @input="startYear_1 = checkInputLength(startYear_1, 3)"
                  @blur="startYear_1 = checkInputLength(startYear_1, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="startYearUnit_1"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-start-1-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">到</span>
                <input
                  type="number"
                  min="0"
                  v-model="endYear_1"
                  @input="endYear_1 = checkInputLength(endYear_1, 3)"
                  @blur="endYear_1 = checkInputLength(endYear_1, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="yearUnitEnd_1"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-end-1-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
              </div>
              <!-- 保障期間-2 -->
              <div class="radio radio-inline mb-15">
                <input type="radio" id="coveragePeriod-2" v-model="coveragePeriod" value="2">
                <label class="hide-label" for="coveragePeriod-2"></label>
                <span class="lh-40 ml-50">第</span>
                <input
                  type="number"
                  min="0"
                  v-model="startYear_2"
                  @input="startYear_2 = checkInputLength(startYear_2, 3)"
                  @blur="startYear_2 = checkInputLength(startYear_2, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="startYearUnit_2"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-start-2-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="yearUnitEnd_2"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option value="3">繳費期滿</option>
                </select>
              </div>
              <!-- 保障期間-3 -->
              <div class="radio radio-inline mb-15">
                <input type="radio" id="coveragePeriod-3" v-model="coveragePeriod" value="3">
                <label class="hide-label" for="coveragePeriod-3"></label>
                <span class="lh-40 ml-50">第</span>
                <input
                  type="number"
                  min="0"
                  v-model="startYear_3"
                  @input="startYear_3 = checkInputLength(startYear_3, 3)"
                  @blur="startYear_3 = checkInputLength(startYear_3, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="startYearUnit_3"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-start-3-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">之後</span>
              </div>
            </div>
          </div>
          <!-- 保障公式 -->
          <div class="form-group row">
            <label class="col-1 text-right">保障公式</label>
            <div class="col-11 d-inline-grid">
              <div class="lh-40" v-html="coveragePreviewText"></div>
              <!-- 保障公式-1 -->
              <div class="checkbox radio-inline mb-15">
                <select
                  v-model="maxormin"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option value="0"></option>
                  <option value="1">MAX</option>
                  <option value="2">MIN</option>
                </select>
                <span class="lh-40">(</span>
                <select
                  v-model="calculationbasis_first"
                  @change="updateCoveragePreviewText()"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option v-for="item in calculationbasis" :key="`calculation-basis-first-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasisfirst_value"
                  @input="calculationbasisfirst_value = checkInputLength(calculationbasisfirst_value, 8)"
                  @blur="calculationbasisfirst_value = checkInputLength(calculationbasisfirst_value, 8)"
                  @change="updateCoveragePreviewText()"
                  :class="{'is-invalid': is_calculationbasisfirst_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_first"
                  @change="updateCoveragePreviewText()"
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerate" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率</span>
              </div>
              <!-- 保障公式-2 -->
              <div class="checkbox radio-inline mb-15">
                <select
                  v-if="maxormin == '0'" 
                  v-model="operator"
                  :class="{'is-invalid': is_operator_Error}"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in operatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else
                  v-model="operator"
                  :class="{'is-invalid': is_operator_Error}"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in allOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="calculationbasis_second"
                  @change="updateCoveragePreviewText()"
                  :class="{'is-invalid': is_calculationbasis_second_Error}"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option value="0"></option>
                  <option v-for="item in calculationbasis" :key="`calculation-basis-second-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasissecond_value"
                  @input="calculationbasissecond_value = checkInputLength(calculationbasissecond_value, 8)"
                  @blur="calculationbasissecond_value = checkInputLength(calculationbasissecond_value, 8)"
                  @change="updateCoveragePreviewText()"
                  :class="{'is-invalid': is_calculationbasissecond_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_second"
                  @change="updateCoveragePreviewText()"
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerate" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率</span>
              </div>
              <!-- 保障公式-3 -->
              <div class="checkbox radio-inline mb-15">
                <select
                  v-if="operator2Type == '1'" 
                  v-model="operator2"
                  :disabled="isGroup3Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in allOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else-if="operator2Type == '2'" 
                  v-model="operator2"
                  :disabled="isGroup3Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in operatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else
                  v-model="operator2"
                  :disabled="isGroup3Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in singleOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="calculationbasis_third"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup3Disabled" 
                  :class="{'is-invalid': is_calculationbasis_third_Error}"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option value="0"></option>
                  <option v-for="item in calculationbasis" :key="`calculation-basis-3-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasisthird_value"
                  @input="calculationbasisthird_value = checkInputLength(calculationbasisthird_value, 8)"
                  @blur="calculationbasisthird_value = checkInputLength(calculationbasisthird_value, 8)"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup3Disabled" 
                  :class="{'is-invalid': is_calculationbasisthird_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_third"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup3Disabled" 
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerate" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率</span>
              </div>
              <!-- 保障公式-4 -->
              <div class="checkbox radio-inline mb-15">
                <select
                  v-if="operator3Type == '1'" 
                  v-model="operator3"
                  :disabled="isGroup4Disabled"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in allOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else-if="operator3Type == '2'" 
                  v-model="operator3"
                  :disabled="isGroup4Disabled"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in operatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else
                  v-model="operator3"
                  :disabled="isGroup4Disabled"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in singleOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="calculationbasis_fourth"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup4Disabled"
                  :class="{'is-invalid': is_calculationbasis_fourth_Error}"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option value="0"></option>
                  <option v-for="item in calculationbasis" :key="`calculation-basis-4-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasisfourth_value"
                  @input="calculationbasisfourth_value = checkInputLength(calculationbasisfourth_value, 8)"
                  @blur="calculationbasisfourth_value = checkInputLength(calculationbasisfourth_value, 8)"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup4Disabled"
                  :class="{'is-invalid': is_calculationbasisfourth_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_fourth"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup4Disabled"
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerate" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率</span>
              </div>
              <!-- 保障公式-5 -->
              <div class="checkbox radio-inline mb-15">
                <select
                  v-if="operator4Type == '1'" 
                  v-model="operator4"
                  :disabled="isGroup5Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in allOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else-if="operator4Type == '2'" 
                  v-model="operator4"
                  :disabled="isGroup5Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in operatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else
                  v-model="operator4"
                  :disabled="isGroup5Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in singleOperatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="calculationbasis_fifth"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup5Disabled" 
                  :class="{'is-invalid': is_calculationbasis_fifth_Error}"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option value="0"></option>
                  <option v-for="item in calculationbasis" :key="`calculation-basis-5-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasisfifth_value"
                  @input="calculationbasisfifth_value = checkInputLength(calculationbasisfifth_value, 8)"
                  @blur="calculationbasisfifth_value = checkInputLength(calculationbasisfifth_value, 8)"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup5Disabled" 
                  :class="{'is-invalid': is_calculationbasisfifth_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_fifth"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup5Disabled" 
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerate" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率</span>
              </div>
              <!-- 保障公式-6 -->
              <div class="checkbox radio-inline mb-15">
                <select
                  v-model="operator5"
                  :disabled="isGroup6Disabled" 
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in operatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="calculationbasis_sixth"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup6Disabled" 
                  :class="{'is-invalid': is_calculationbasis_sixth_Error}"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option value="0"></option>
                  <option v-for="item in calculationbasis" :key="`calculation-basis-6-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasissixth_value"
                  @input="calculationbasissixth_value = checkInputLength(calculationbasissixth_value, 8)"
                  @blur="calculationbasissixth_value = checkInputLength(calculationbasissixth_value, 8)"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup6Disabled" 
                  :class="{'is-invalid': is_calculationbasissixth_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_sixth"
                  @change="updateCoveragePreviewText()"
                  :disabled="isGroup6Disabled" 
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerate" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率)</span>
              </div>
            </div>
          </div>
          <!--保障終期-->
          <div class="text-left ml-15">
            <div class="radio radio-inline mb-15">
              <span class="lh-40">保障至主約主被保人</span>
              <input
                type="number"
                min="0"
                @input="age_limt = checkInputLength(age_limt, 3)"
                @blur="age_limt = checkInputLength(age_limt, 3)"
                v-model="age_limt"
                class="form-control form-control-inline show-input w-100"
                />
              <span class="lh-40">歲止</span>
            </div>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doUpdate" v-if="isEditMode">更新</button>
            <button type="button" class="btn btn-primary" @click="doInsert" v-else>新增</button>
            <button type="button" class="btn btn-default" @click="doCancel">取消</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mt-40">
      <button type="button" class="btn btn-default"  @click="doDeleteAll">
      全部刪除
      </button>
    </div>
    <div class="col-12">
      <table class="table datatable">
        <thead>
          <tr>
            <th class="text-center" style="width:15%;">排序</th>
            <th class="text-center" style="width:15%;">編輯/刪除</th>
            <th class="text-center" style="width:70%;">保障公式輸入結果</th>
          </tr>
        </thead>
        <tbody v-if="formulaData.length">
          <tr v-for="(item, i) in formulaData" :key="`formula-data-${item.investtype_formula_id}`">
            <td class="text-center" :class="{'active':editIndex === i}">
              <button
                type="button"
                class="btn btn-default fa fa-arrow-up"
                @click="doUpdatePriority(i,-1)"
                :disabled="i === 0 || isEditMode"
                >
              </button>
              <button
                type="button"
                class="btn btn-default fa fa-arrow-down"
                @click="doUpdatePriority(i,1)"
                :disabled="i === formulaData.length-1 || isEditMode"
                >
              </button>
            </td>
            <td class="text-center" :class="{'active':editIndex === i}">
              <button 
                type="button" 
                class="btn btn-sm btn-primary fs-12" 
                :disabled="isEditMode" 
                @click="switchEditMode(item,i)"
                >
              編輯
              </button>
              <button 
                type="button" 
                class="btn btn-sm btn-default fs-12" 
                :disabled="isEditMode" 
                @click="doDelete(item)"
                >
              刪除
              </button>
            </td>
            <td :class="{'active':editIndex === i}">
              {{ item.formula_detail }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">
              <h3 class="mb-3">查無保障公式</h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  getDeathAndDisabilityFormula,
  addInvestFormula,
  deleteAllInvestFormula,
  deleteInvestFormula,
  updateInvestFormula,
  updateInvestFormulaPriority,
} from "@/service";
export default {
  name: "InvestDeathAndDisabilityBenefit",
  data() {
    return {
      productData: {},
      formulaData: [],
      yearperiod: "",
      coveragePeriod: "1",
      maxormin: "0",
      calculationbasis_first: "4",
      calculationbasisfirst_value: null,
      exchangerate_first: "0",
      calculationbasis_second: "0",
      calculationbasissecond_value: null,
      exchangerate_second: "0",
      calculationbasis_third: "0",
      calculationbasisthird_value: null,
      exchangerate_third: "0",
      calculationbasis_fourth: "0",
      calculationbasisfourth_value: null,
      exchangerate_fourth: "0",
      calculationbasis_fifth: "0",
      calculationbasisfifth_value: null,
      exchangerate_fifth: "0",
      calculationbasis_sixth: "0",
      calculationbasissixth_value: null,
      exchangerate_sixth: "0",
      startYear_1: null,
      startYear_2: null,
      startYear_3: null,
      endYear_1: null,
      startYearUnit_1: "1",
      startYearUnit_2: "1",
      startYearUnit_3: "1",
      yearUnitEnd_1: "1",
      yearUnitEnd_2: "3",
      age_limt: null,
      operator: "0",
      operator2: "0",
      operator3: "0",
      operator4: "0",
      operator5: "0",
      // operatorType >>> 1:全部符號 2:只有運算符號 3:只有逗號
      operator2Type: "1",
      operator3Type: "1",
      operator4Type: "1",
      coveragePreviewText: "（基本保額的0倍）",
      is_calculationbasisfirst_value_Error: false,
      is_calculationbasissecond_value_Error: false,
      is_calculationbasis_second_Error: false,
      is_calculationbasisthird_value_Error: false,
      is_calculationbasis_third_Error: false,
      is_calculationbasisfourth_value_Error: false,
      is_calculationbasis_fourth_Error: false,
      is_calculationbasisfifth_value_Error: false,
      is_calculationbasis_fifth_Error: false,
      is_calculationbasissixth_value_Error: false,
      is_calculationbasis_sixth_Error: false,
      is_operator_Error: false,
      is_operator2_Error: false,
      is_operator3_Error: false,
      is_operator4_Error: false,
      is_operator5_Error: false,
      isGroup3Disabled: true,
      isGroup4Disabled: true,
      isGroup5Disabled: true,
      isGroup6Disabled: true,

      isLoading: false,
      isEditMode: false,
      editIndex: -1,
      editFomulaId: "",
      yearType: [
        {
          text: "所有年期",
          value: "",
        },
      ],
      year_unit: [
        {
          text: "年",
          value: "1",
        },
        {
          text: "歲",
          value: "2",
        },
      ],
      calculationbasis: [
        {
          text: "基本保額",
          value: "4",
        },
        {
          text: "保單價值",
          value: "128",
        },
        {
          text: "保證最低身故金額",
          value: "512",
        },
        {
          text: "總繳年繳化表定保費",
          value: "8192",
        },
        {
          text: "總繳表定保費",
          value: "131072",
        },
        {
          text: "保險金扣除額",
          value: "3",
        },
        {
          text: "總繳保險費",
          value: "5",
        },
        {
          text: "部分提領金額",
          value: "6",
        },
      ],
      operatorOption: [
        {
          text: "",
          value: "0",
        },
        {
          text: "＋",
          value: "1",
        },
        {
          text: "－",
          value: "2",
        },
      ],
      allOperatorOption: [
        {
          text: "",
          value: "0",
        },
        {
          text: "，",
          value: "5",
        },
        {
          text: "＋",
          value: "1",
        },
        {
          text: "－",
          value: "2",
        },
      ],
      singleOperatorOption: [
        {
          text: "",
          value: "0",
        },
        {
          text: "，",
          value: "5",
        },
      ],
      exchangerate: [
        {
          text: "",
          value: "0",
        },
        {
          text: "美元(USD)",
          value: "2",
        },
        {
          text: "澳幣(AUD)",
          value: "3",
        },
        {
          text: "英鎊(GBP)",
          value: "4",
        },
        {
          text: "歐元(EUR)",
          value: "5",
        },
        {
          text: "紐幣(NZD)",
          value: "6",
        },
        {
          text: "港幣(HKD)",
          value: "7",
        },
        {
          text: "日幣(JPY)",
          value: "8",
        },
        {
          text: "人民幣(CNY)",
          value: "9",
        },
        {
          text: "南非幣(ZAR)",
          value: "10",
        },
      ],
    };
  },
  watch: {
    maxormin: function(val) {
      if (val != "0") {
        this.isGroup3Disabled = false;
        this.isGroup4Disabled = false;
        if (!(this.operator == "5" && this.operator2 == "5")) {
          this.isGroup5Disabled = false;
        }
        if (!((this.operator == "5" && this.operator2 == "5") 
        || (this.operator == "5" && this.operator3 == "5") 
        || (this.operator2 == "5" && this.operator3 == "5"))) {
          this.isGroup6Disabled = false;
        }
      } else {
        // this.operator = "0";
        this.setGroupDisabled(3);
        this.setGroupDisabled(4);
        this.setGroupDisabled(5);
        this.setGroupDisabled(6);
      }
      this.updateCoveragePreviewText();
    },
    operator: function(val) {
      if (this.maxormin != "0") {
        if (val != "5" && val != "0") {
          this.operator2Type = "3";
        } else {
          this.operator2Type = "1";
        }

        if (val == "5") {
          this.setGroupDisabled(6);
          if (val == "5" && this.operator2 == "5") {
            this.setGroupDisabled(5);
          }
        } else {
          this.isGroup5Disabled = false;
          this.isGroup6Disabled = false;
        }
      }
      this.updateCoveragePreviewText();
    },
    operator2: function(val) {
      if (this.maxormin != "0") {
        if (val != "5" && val != "0") {
          this.operator3Type = "3";
        } else if (val == "5" && this.operator == "5") {
          this.operator3Type = "2";
        } else {
          this.operator3Type = "1";
        }

        if (val == "5" && this.operator == "5") {
          this.setGroupDisabled(5);
          this.setGroupDisabled(6);
        } else {
          this.operator3Type = "1";
          this.isGroup5Disabled = false;
          if (this.operator != "5") {
            this.isGroup6Disabled = false;
          }
        }
      }
      this.updateCoveragePreviewText();
    },
    operator3: function(val) {
      if (this.maxormin != "0") {
        if (val != "5" && val != "0") {
          this.operator4Type = "3";
        } else if ((val == "5" && this.operator == "5" )
          || (val == "5" && this.operator2 == "5")) {
          this.operator4Type = "2";
        } else {
          this.operator4Type = "1";
        }

        if ((val == "5" && this.operator == "5" )
          || (val == "5" && this.operator2 == "5")
          || (this.operator == "5" && this.operator2 == "5")) {
          this.setGroupDisabled(6);
        } else {
          this.isGroup6Disabled = false;
        }
      }
      this.updateCoveragePreviewText();
    },
    operator4: function(val) {
      if (this.maxormin != "0") {
        if (val != "5" && val != "0") {
          this.operator5Type = "3";
        } else {
          this.operator5Type = "1";
        }
      }
      this.updateCoveragePreviewText();
    },
    operator5: function() {
      this.updateCoveragePreviewText();
    },
  },
  methods: {
    init() {
      this.formulaData = [];
      this.doCancel();
      this.isLoading = true;
      getDeathAndDisabilityFormula(
        this.$store.state.userInfo.id,
        this.productData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formulaData = result.data.investformula.sort(
            (a, b) => parseInt(a.priority) - parseInt(b.priority)
          );
        }
        this.isLoading = false;
      });
    },
    doCancel() {
      if (this.isEditMode) {
        this.isEditMode = false;
        this.editIndex = -1;
        this.editFomulaId = "";
      }
      this.is_calculationbasisfirst_value_Error = false;
      this.is_calculationbasissecond_value_Error = false;
      this.is_calculationbasis_second_Error = false;
      this.is_calculationbasisthird_value_Error = false;
      this.is_calculationbasis_third_Error = false;
      this.is_calculationbasisfourth_value_Error = false;
      this.is_calculationbasis_fourth_Error = false;
      this.is_calculationbasisfifth_value_Error = false;
      this.is_calculationbasis_fifth_Error = false;
      this.is_calculationbasissixth_value_Error = false;
      this.is_calculationbasis_sixth_Error = false;
      this.is_operator_Error = false;
      this.is_operator2_Error = false;
      this.is_operator3_Error = false;
      this.is_operator4_Error = false;
      this.is_operator5_Error = false;
      this.isGroup3Disabled = true;
      this.isGroup4Disabled = true;
      this.isGroup5Disabled = true;
      this.isGroup6Disabled = true;
      this.yearperiod = "";
      this.coveragePeriod = "1";
      this.maxormin = "0";
      this.calculationbasis_first = "4";
      this.calculationbasisfirst_value = null;
      this.exchangerate_first = "0";
      this.calculationbasis_second = "0";
      this.calculationbasissecond_value = null;
      this.exchangerate_second = "0";
      this.calculationbasis_third = "0";
      this.calculationbasisthird_value = null;
      this.exchangerate_third = "0";
      this.calculationbasis_fourth = "0";
      this.calculationbasisfourth_value = null;
      this.exchangerate_fourth = "0";
      this.calculationbasis_fifth = "0";
      this.calculationbasisfifth_value = null;
      this.exchangerate_fifth = "0";
      this.calculationbasis_sixth = "0";
      this.calculationbasissixth_value = null;
      this.exchangerate_sixth = "0";
      this.startYear_1 = null;
      this.startYear_2 = null;
      this.startYear_3 = null;
      this.endYear_1 = null;
      this.startYearUnit_1 = "1";
      this.startYearUnit_2 = "1";
      this.startYearUnit_3 = "1";
      this.yearUnitEnd_1 = "1";
      this.yearUnitEnd_2 = "3";
      this.age_limt = null;
      this.operator = "0";
      this.operator2 = "0";
      this.operator3 = "0";
      this.operator4 = "0";
      this.operator5 = "0";
    },
    doInsert() {
      if (this.doValidate()) {
        return;
      }
      let reqData = this.getReqData();
      this.isLoading = true;
      addInvestFormula(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "新增成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    getStartYear() {
      if (this.coveragePeriod == "1") {
        return this.startYear_1 ? this.startYear_1 : "0";
      } else if (this.coveragePeriod == "2") {
        return this.startYear_2 ? this.startYear_2 : "0";
      } else if (this.coveragePeriod == "3") {
        return this.startYear_3 ? this.startYear_3 : "0";
      } else {
        return "0";
      }
    },
    setStartYear(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.startYear_1 = parseInt(value) === 0 ? null : parseInt(value);
      } else if (coveragePeriod == "2") {
        this.startYear_2 = parseInt(value) === 0 ? null : parseInt(value);
      } else if (coveragePeriod == "3") {
        this.startYear_3 = parseInt(value) === 0 ? null : parseInt(value);
      }
    },
    getEndYear() {
      if (this.coveragePeriod == "1") {
        return this.endYear_1 ? this.endYear_1 : "0";
      } else {
        return "0";
      }
    },
    setEndYear(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.endYear_1 = parseInt(value) === 0 ? null : parseInt(value);
      }
    },
    getStartYearUnit() {
      if (this.coveragePeriod == "1") {
        return this.startYearUnit_1;
      } else if (this.coveragePeriod == "2") {
        return this.startYearUnit_2;
      } else if (this.coveragePeriod == "3") {
        return this.startYearUnit_3;
      } else {
        return "0";
      }
    },
    setStartYearUnit(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.startYearUnit_1 = value;
      } else if (coveragePeriod == "2") {
        this.startYearUnit_2 = value;
      } else if (coveragePeriod == "3") {
        this.startYearUnit_3 = value;
      }
    },
    getEndYearUnit() {
      if (this.coveragePeriod == "1") {
        return this.yearUnitEnd_1;
      } else if (this.coveragePeriod == "2") {
        return this.yearUnitEnd_2;
      } else {
        return "0";
      }
    },
    setEndYearUnit(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.yearUnitEnd_1 = value;
      } else if (coveragePeriod == "2") {
        this.yearUnitEnd_2 = value;
      }
    },
    doUpdatePriority(index, shift) {
      let thisItem = this.formulaData.map(
        ({ formula_detail, ...keepAttrs }) => keepAttrs
      )[index];
      let targetItem = this.formulaData.map(
        ({ formula_detail, ...keepAttrs }) => keepAttrs
      )[index + shift];
      thisItem.priority = thisItem.priority + shift;
      targetItem.priority = targetItem.priority - shift;

      let reqList = [];
      reqList.push(thisItem);
      reqList.push(targetItem);

      this.isLoading = true;
      updateInvestFormulaPriority(this.$store.state.userInfo.id, reqList).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    doUpdate() {
      if (this.doValidate()) {
        return;
      }
      let reqData = this.getReqData();
      reqData.investtype_formula_id = this.editFomulaId;
      updateInvestFormula(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    doDelete(item) {
      if (confirm("確認要刪除此筆資料!?")) {
        this.isLoading = true;

        let reqData = {
          productid: this.productData.productId,
          company: this.productData.company.COMPSNM,
          insuranceName: this.productData.insuranceName,
          insuranceCode: this.productData.insuranceCode,
          investtype_formula_id: item.investtype_formula_id,
          detail: item.formula_detail.replaceAll("%", "％"),
          userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
          userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        };
        deleteInvestFormula(this.$store.state.userInfo.id, reqData).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: "無保障公式可刪除" });
            }
            this.isLoading = false;
          }
        );
      }
    },
    doDeleteAll() {
      if (confirm("確認要刪除所有資料!?")) {
        this.isLoading = true;
        let deleteTypeList = [2]; //2:身故及完全失能保險金
        deleteAllInvestFormula(this.$store.state.userInfo.id, {
          productid: this.productData.productId,
          company: this.productData.company.COMPSNM,
          insuranceName: this.productData.insuranceName,
          insuranceCode: this.productData.insuranceCode,
          deletetypelist: deleteTypeList,
          detail: this.formulaData.map(x => x.formula_detail.replaceAll("%", "％")),
        }).then((result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "刪除成功" });
            this.init();
          } else {
            this.$toast.info({ title: "無保障公式可刪除" });
          }
          this.isLoading = false;
        });
      }
    },
    switchEditMode(item, index) {
      this.isEditMode = true;
      this.is_calculationbasisfirst_value_Error = false;
      this.is_calculationbasissecond_value_Error = false;
      this.is_calculationbasis_second_Error = false;
      this.is_calculationbasisthird_value_Error = false;
      this.is_calculationbasis_third_Error = false;
      this.is_calculationbasisfourth_value_Error = false;
      this.is_calculationbasis_fourth_Error = false;
      this.is_operator_Error = false;
      this.is_operator2_Error = false;
      this.is_operator3_Error = false;
      this.editIndex = index;
      this.editFomulaId = item.investtype_formula_id;
      this.coveragePeriod = this.getCoveragePeriod(item);
      this.setStartYear(this.coveragePeriod, item.start_year);
      this.setStartYearUnit(this.coveragePeriod, item.start_year_unit);
      this.setEndYearUnit(this.coveragePeriod, item.end_year_unit);
      this.setEndYear(this.coveragePeriod, item.end_year);
      this.maxormin = item.maxormin;
      this.calculationbasis_first = item.calculationbasis_first;
      this.calculationbasisfirst_value = item.calculationbasisfirst_value;
      this.exchangerate_first = item.exchangerate_first === undefined ? "0" : item.exchangerate_first;
      this.operator = item.operator;
      this.calculationbasis_second = item.calculationbasis_second;
      this.calculationbasissecond_value =
        item.calculationbasissecond_value == "0"
          ? null
          : item.calculationbasissecond_value;
      this.exchangerate_second = item.exchangerate_second === undefined ? "0" : item.exchangerate_second;
      this.operator2 = item.operator2 === undefined ? "0" : item.operator2;
      this.calculationbasis_third = 
        item.calculationbasis_third === undefined 
          ? "0" 
          : item.calculationbasis_third;
      this.calculationbasisthird_value =
        item.calculationbasisthird_value == "0"
          ? null
          : item.calculationbasisthird_value;
      this.exchangerate_third = item.exchangerate_third === undefined ? "0" : item.exchangerate_third;
      this.operator3 = item.operator3 === undefined ? "0" : item.operator3;
      this.calculationbasis_fourth = 
        item.calculationbasis_fourth === undefined 
          ? "0" 
          : item.calculationbasis_fourth;
      this.calculationbasisfourth_value =
        item.calculationbasisfourth_value == "0"
          ? null
          : item.calculationbasisfourth_value;
      this.exchangerate_fourth = item.exchangerate_fourth === undefined ? "0" : item.exchangerate_fourth;
      this.operator4 = item.operator4 === undefined ? "0" : item.operator4;
      this.calculationbasis_fifth = 
        item.calculationbasis_fifth === undefined 
          ? "0" 
          : item.calculationbasis_fifth;
      this.calculationbasisfifth_value =
        item.calculationbasisfifth_value == "0"
          ? null
          : item.calculationbasisfifth_value;
      this.exchangerate_fifth = item.exchangerate_fifth === undefined ? "0" : item.exchangerate_fifth;
      this.operator5 = item.operator5 === undefined ? "0" : item.operator5;
      this.calculationbasis_sixth = 
        item.calculationbasis_sixth === undefined 
          ? "0" 
          : item.calculationbasis_sixth;
      this.calculationbasissixth_value =
        item.calculationbasissixth_value == "0"
          ? null
          : item.calculationbasissixth_value;
      this.exchangerate_sixth = item.exchangerate_sixth === undefined ? "0" : item.exchangerate_sixth;
      this.age_limt = item.age_limt ? item.age_limt : "";
      this.yearperiod =
        item.yearperiod && item.year_type && item.year_type != "0"
          ? item.yearperiod + "-" + item.year_type
          : "";
      this.isGroup3Disabled = item.maxormin == "0";
      this.isGroup4Disabled = item.maxormin == "0";
    },
    getCoveragePeriod(item) {
      if (item.start_year_unit == "0" && item.end_year_unit == "0") {
        return "1";
      } else if (item.end_year_unit == "3") {
        return "2";
      } else if (item.end_year_unit == "0") {
        return "3";
      }
      return "1";
    },
    getReqData() {
      return {
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        productid: this.productData.productId,
        ageperiods: this.productData.ageperiods,
        terminableperiods: this.productData.terminableperiods,
        productname: this.productData.insuranceName,
        productcode: this.productData.insuranceCode,
        company: this.productData.company.COMPSNM,
        formulatype: 2, //2:身故及失能保險金
        underwriting_target: "1", //1:本人
        yearperiod: this.yearperiod ? this.yearperiod.split("-")[0] : "",
        year_type: this.yearperiod ? this.yearperiod.split("-")[1] : "0",
        start_year: this.getStartYear(),
        start_year_unit: this.getStartYearUnit(),
        end_year: this.getEndYear(),
        end_year_unit: this.getEndYearUnit(),
        maxormin: this.maxormin,
        calculationbasis_first: this.calculationbasis_first,
        calculationbasisfirst_value: this.calculationbasisfirst_value,
        calculationbasisfirst_unit: "3", //固定放3
        exchangerate_first: this.exchangerate_first,
        operator: this.operator,
        operator2: this.operator2,
        operator3: this.operator3,
        operator4: this.operator4,
        operator5: this.operator5,
        calculationbasis_second: this.calculationbasis_second,
        calculationbasissecond_value: this.calculationbasissecond_value
          ? this.calculationbasissecond_value
          : "0",
        calculationbasissecond_unit:
          this.calculationbasis_second && this.calculationbasissecond_value
            ? "3"
            : "0",
        exchangerate_second: this.exchangerate_second,
        calculationbasis_third: this.calculationbasis_third,
        calculationbasisthird_value: this.calculationbasisthird_value
          ? this.calculationbasisthird_value
          : "0",
        calculationbasisthird_unit:
          this.calculationbasis_third && this.calculationbasisthird_value
            ? "3"
            : "0",
        exchangerate_third: this.exchangerate_third,
        calculationbasis_fourth: this.calculationbasis_fourth,
        calculationbasisfourth_value: this.calculationbasisfourth_value
          ? this.calculationbasisfourth_value
          : "0",
        calculationbasisfourth_unit:
          this.calculationbasis_fourth && this.calculationbasisfourth_value
            ? "3"
            : "0",
        exchangerate_fourth: this.exchangerate_fourth,
        calculationbasis_fifth: this.calculationbasis_fifth,
        calculationbasisfifth_value: this.calculationbasisfifth_value
          ? this.calculationbasisfifth_value
          : "0",
        calculationbasisfifth_unit:
          this.calculationbasis_fifth && this.calculationbasisfifth_value
            ? "3"
            : "0",
        exchangerate_fifth: this.exchangerate_fifth,
        calculationbasis_sixth: this.calculationbasis_sixth,
        calculationbasissixth_value: this.calculationbasissixth_value
          ? this.calculationbasissixth_value
          : "0",
        calculationbasissixth_unit:
          this.calculationbasis_sixth && this.calculationbasissixth_value
            ? "3"
            : "0",
        exchangerate_sixth: this.exchangerate_sixth,
        rewardsrate_point: "0",
        priority:
          this.formulaData.length > 0
            ? parseInt(this.formulaData[this.formulaData.length - 1].priority) +
              1
            : 1,
        age_limt: this.age_limt ? this.age_limt : "0",
      };
    },
    doValidate() {
      let isError = false;
      this.is_calculationbasisfirst_value_Error = false;
      this.is_operator_Error = false;
      this.is_calculationbasissecond_value_Error = false;
      this.is_calculationbasis_second_Error = false;
      this.is_operator2_Error = false;
      this.is_calculationbasisthird_value_Error = false;
      this.is_calculationbasis_third_Error = false;
      this.is_operator3_Error = false;
      this.is_calculationbasisfourth_value_Error = false;
      this.is_calculationbasis_fourth_Error = false;
      this.is_operator4_Error = false;
      this.is_calculationbasisfifth_value_Error = false;
      this.is_calculationbasis_fifth_Error = false;
      this.is_operator5_Error = false;
      this.is_calculationbasissixth_value_Error = false;
      this.is_calculationbasis_sixth_Error = false;
      // 第一組
      if (!this.calculationbasisfirst_value) {
        this.$toast.info({ title: "請輸入第一種計算基礎的倍數" });
        this.is_calculationbasisfirst_value_Error = true;
        isError = true;
      }
      // 第二組
      if (this.calculationbasis_second != "0" && this.operator == "0") {
        this.$toast.info({ title: "請輸入第一個運算符號" });
        this.is_operator_Error = true;
        isError = true;
      }
      if (this.calculationbasis_second != "0" && !this.calculationbasissecond_value) {
        this.$toast.info({ title: "請輸入第二種計算基礎的倍數" });
        this.is_calculationbasissecond_value_Error = true;
        isError = true;
      }
      if ( this.calculationbasissecond_value && this.calculationbasis_second == "0" ) {
        this.$toast.info({ title: "請輸入第二種計算基礎" });
        this.is_calculationbasis_second_Error = true;
        isError = true;
      }
      // 第三組
      if (this.calculationbasis_third != "0" && !this.calculationbasisthird_value) {
        this.$toast.info({ title: "請輸入第三種計算基礎的倍數" });
        this.is_calculationbasisthird_value_Error = true;
        isError = true;
      }
      if (this.calculationbasis_third != "0" && this.operator2 == "0") {
        this.$toast.info({ title: "請輸入第二個運算符號" });
        this.is_operator2_Error = true;
        isError = true;
      }
      if (this.calculationbasisthird_value && this.calculationbasis_third == "0") {
        this.$toast.info({ title: "請輸入第三種計算基礎" });
        this.is_calculationbasis_third_Error = true;
        isError = true;
      }
      // 第四組
      if (this.calculationbasis_fourth != "0" && !this.calculationbasisfourth_value) {
        this.$toast.info({ title: "請輸入第四種計算基礎的倍數" });
        this.is_calculationbasisfourth_value_Error = true;
        isError = true;
      }
      if (this.calculationbasis_fourth != "0" && this.operator3 == "0") {
        this.$toast.info({ title: "請輸入第三個運算符號" });
        this.is_operator3_Error = true;
        isError = true;
      }
      if (this.calculationbasisfourth_value && this.calculationbasis_fourth == "0") {
        this.$toast.info({ title: "請輸入第四種計算基礎" });
        this.is_calculationbasis_fourth_Error = true;
        isError = true;
      }
      // 第五組
      if (this.calculationbasis_fifth != "0" && !this.calculationbasisfifth_value) {
        this.$toast.info({ title: "請輸入第五種計算基礎的倍數" });
        this.is_calculationbasisfifth_value_Error = true;
        isError = true;
      }
      if (this.calculationbasis_fifth != "0" && this.operator4 == "0") {
        this.$toast.info({ title: "請輸入第四個運算符號" });
        this.is_operator4_Error = true;
        isError = true;
      }
      if (this.calculationbasisfifth_value && this.calculationbasis_fifth == "0") {
        this.$toast.info({ title: "請輸入第五種計算基礎" });
        this.is_calculationbasis_fifth_Error = true;
        isError = true;
      }
      // 第六組
      if (this.calculationbasis_sixth != "0" && !this.calculationbasissixth_value) {
        this.$toast.info({ title: "請輸入第六種計算基礎的倍數" });
        this.is_calculationbasissixth_value_Error = true;
        isError = true;
      }
      if (this.calculationbasis_sixth != "0" && this.operator5 == "0") {
        this.$toast.info({ title: "請輸入第五個運算符號" });
        this.is_operator5_Error = true;
        isError = true;
      }
      if (this.calculationbasissixth_value && this.calculationbasis_sixth == "0") {
        this.$toast.info({ title: "請輸入第六種計算基礎" });
        this.is_calculationbasis_sixth_Error = true;
        isError = true;
      }
      return isError;
    },
    updateCoveragePreviewText() {
      this.coveragePreviewText = (this.maxormin == "1" ? "MAX" : (this.maxormin == "2" ? "MIN" : "")) 
        + "（"
        + this.getSetText(null, this.calculationbasis_first, this.calculationbasisfirst_value, this.exchangerate_first)
        + this.getSetText(this.operator, this.calculationbasis_second, this.calculationbasissecond_value, this.exchangerate_second)
        + this.getSetText(this.operator2, this.calculationbasis_third, this.calculationbasisthird_value, this.exchangerate_third)
        + this.getSetText(this.operator3, this.calculationbasis_fourth, this.calculationbasisfourth_value, this.exchangerate_fourth)
        + this.getSetText(this.operator4, this.calculationbasis_fifth, this.calculationbasisfifth_value, this.exchangerate_fifth)
        + this.getSetText(this.operator5, this.calculationbasis_sixth, this.calculationbasissixth_value, this.exchangerate_sixth)
        + "）";
    },
    getSetText(operator, basis, value, exchange) {
      let result = "";
      if (basis != "0") {
        result += (operator ? this.getOperatorText(operator) : "")
              + this.getBasisText(basis) + "的" 
              + this.getValueText(value) + "倍";
        if (exchange != "0") {
          result += "X" + this.getExchangeRateText(exchange);
        }
      }
      return result;
    },
    getOperatorText(val) {
      return (val == "5" ? "\n" : "") 
        + this.allOperatorOption.filter((x) => {
          return val == x.value;
        })[0].text;
    },
    getBasisText(val) {
      return this.calculationbasis.filter((x) => {
        return val == x.value;
      })[0].text;
    },
    getValueText(val) {
      return val ? val : "0";
    },
    getExchangeRateText(val) {
      return this.exchangerate.filter((x) => {
        return val == x.value;
      })[0].text;
    },
    setGroupDisabled(group) {
      switch(group) {
        case 3: 
          this.isGroup3Disabled = true;
          this.operator2 = "0";
          this.calculationbasis_third = "0";
          this.calculationbasisthird_value = null;
          this.exchangerate_third = "0";
          break;
        case 4: 
          this.isGroup4Disabled = true;
          this.operator3 = "0";
          this.calculationbasis_fourth = "0";
          this.calculationbasisfourth_value = null;
          this.exchangerate_fourth = "0";
          break;
        case 5: 
          this.isGroup5Disabled = true;
          this.operator4 = "0";
          this.calculationbasis_fifth = "0";
          this.calculationbasisfifth_value = null;
          this.exchangerate_fifth = "0";
          break;
        case 6:
          this.isGroup6Disabled = true;
          this.operator5 = "0";
          this.calculationbasis_sixth = "0";
          this.calculationbasissixth_value = null;
          this.exchangerate_sixth = "0";
          break;
        default:
          break;
      }
    },
    checkInputLength(value, length) {
      if (value.length > length) {
        return value.slice(0, length);
      }
      return value;
    },
  },
  beforeMount() {
    this.productData = JSON.parse(localStorage.productData);
    this.yearType = this.productData.ageperiods
      ? [
          ...this.yearType,
          ...this.productData.ageperiods.split(",").map((x) => {
            return { text: x + "歲", value: x + "-2" };
          }),
        ]
      : this.yearType;
    this.yearType = this.productData.terminableperiods
      ? [
          ...this.yearType,
          ...this.productData.terminableperiods.split(",").map((x) => {
            return { text: x + "年期", value: x + "-1" };
          }),
        ]
      : this.yearType;
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}
.fs-12 {
  font-size: 12px;
}
.mr-0 {
  margin-right: 0px !important;
}
.ml-15 {
  margin-left: 15px;
}
.lh-40 {
  line-height: 40px;
}
.w-80 {
  width: 80px !important;
}
.w-100 {
  width: 100px !important;
}
.w-150 {
  width: 150px !important;
}
.w-250 {
  width: 250px !important;
}
.mb-15 {
  margin-bottom: 15px;
}
.ml-50 {
  margin-left: 50px !important;
}
.show-input {
  opacity: unset;
  position: unset;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
.hide-label {
  height: 0;
}
.active {
  background-color: #f5dec5;
}
</style>
